import { render, staticRenderFns } from "./MobileLife.vue?vue&type=template&id=3796bb43&scoped=true&"
import script from "./MobileLife.vue?vue&type=script&lang=js&"
export * from "./MobileLife.vue?vue&type=script&lang=js&"
import style0 from "./MobileLife.vue?vue&type=style&index=0&id=3796bb43&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3796bb43",
  null
  
)

export default component.exports